import React, { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import logo from "../asset/logowhite.png";
import loginbg from "../asset/login/login.png";
import { useNavigate } from "react-router-dom";
import SummaryApi from "../common";

const InstructorForgotPassword = () => {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const email = localStorage.getItem("instructor_email");

    if (!email) {
      toast.error("Email not found. Please go back and login again.");
      return;
    }

    if (!newPassword || !confirmPassword) {
      toast.error("Please fill in both password fields.");
      return;
    }

    if (newPassword !== confirmPassword) {
      toast.error("Passwords do not match.");
      return;
    }

    try {
      const response = await fetch(SummaryApi.instructorUpdateForgotPassword.url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email,
          newPassword,
        }),
      });

      const data = await response.json();

      if (data.status === true) {
        toast.success("Password updated successfully!");

        if (data.instructor_id) {
          sessionStorage.setItem("login_identifier", email);
          sessionStorage.setItem("instructor_id", data.instructor_id);
          sessionStorage.setItem("H7Z4L9VD2XK5JW8QRYT6", "active");
          console.log("Saved instructor_id:", sessionStorage.getItem("instructor_id"));
          console.log("Saved login_identifier:", sessionStorage.getItem("login_identifier"));
          console.log("Saved session token:", sessionStorage.getItem("H7Z4L9VD2XK5JW8QRYT6"));
        }

        localStorage.removeItem("instructor_email");
        setTimeout(() => {
          navigate("/instructor-panel/dashboard");
        }, 1500); // Delay so toast shows
      } else {
        toast.error(data.message || "Failed to update password.");
      }
    } catch (error) {
      console.error("Password update error:", error);
      toast.error("Something went wrong. Please try again.");
    }
  };

  return (
    <div className="min-h-screen w-full bg-white flex items-center justify-center">
      <div className="w-full max-w-7xl min-h-[650px] flex rounded-3xl overflow-hidden shadow-lg">
        <div className="w-1/2 relative">
          <img
            src={loginbg}
            alt="Instructor Background"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black bg-opacity-30" />
          <div className="relative z-10 flex items-center justify-center h-full">
            <img src={logo} alt="Logo" className="w-64" />
          </div>
        </div>

        {/* Right Side - Password Reset Form */}
        <div className="w-1/2 bg-white flex items-start justify-center pt-12 px-10">
          <div className="w-full max-w-md">
            <h2 className="text-[32px] font-bold text-blue-900 mb-10 text-center font-inter">
              Reset Password
            </h2>

            <form className="space-y-6" onSubmit={handleSubmit}>
              {/* New Password */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  New Password
                </label>
                <input
                  type="password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 outline-none"
                  placeholder="Enter new password"
                />
              </div>

              {/* Confirm Password */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Confirm Password
                </label>
                <input
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 outline-none"
                  placeholder="Re-enter password"
                />
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                className="w-full py-3 bg-blue-900 hover:bg-blue-800 text-white font-semibold rounded-lg shadow-md transition duration-200 font-inter mt-6"
              >
                UPDATE PASSWORD
              </button>
            </form>
          </div>
        </div>
      </div>

      {/* Toast container */}
      <ToastContainer />
    </div>
  );
};

export default InstructorForgotPassword;
